
document.documentElement.classList.replace('no-js','js');
function setupMotion(root=document){
 root.querySelectorAll('.motion-story').forEach(section=>{
 if(section.dataset.ready)return;section.dataset.ready='true';
 const video=section.querySelector('.local-video'),toggle=section.querySelector('[data-motion-toggle]');
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if(reduce){section.classList.add('motion-paused');if(toggle)toggle.textContent=toggle.dataset.play;}
 if(video&&video.dataset.autoplay==='true'&&!reduce){
  if('IntersectionObserver' in window){new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&!section.classList.contains('motion-paused'))video.play().catch(()=>{});else video.pause();}),{threshold:.25}).observe(video);}
 }
 if(toggle)toggle.addEventListener('click',()=>{
  const paused=section.classList.toggle('motion-paused');
  toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;
  if(video){if(paused)video.pause();else video.play().catch(()=>{});}
  toggle.setAttribute('aria-pressed',String(paused));
 });
 });
}
setupMotion();document.addEventListener('shopify:section:load',e=>setupMotion(e.target));
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mobile-menu[open]').forEach(el=>el.removeAttribute('open'));});
document.addEventListener('click',e=>{document.querySelectorAll('.mobile-menu[open]').forEach(el=>{if(!el.contains(e.target))el.removeAttribute('open');});});
